import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { DayOfWeekSchema, StoreUpdateHoursRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// UpdateStoreOperatingHoursRequest::prepareForValidation
const normalize = fieldNormalizer({
  lists: [
    {
      key: 'operating_hours',
      spec: {
        enums: [{ field: 'day_of_week', options: DayOfWeekSchema.options }],
        bool: ['is_open'],
        trimmedOrNull: ['open_time', 'close_time']
      }
    }
  ]
})

const schema = StoreUpdateHoursRequestSchema.strict()

export const StoreUpdateHours = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema).superRefine((value, issues) => {
    // UpdateStoreOperatingHoursRequest::withValidator: an open day needs both times
    value.operating_hours.forEach((row, index) => {
      if (row.is_open && (row.open_time === null || row.open_time === undefined)) {
        issues.addIssue({
          code: 'custom',
          message: 'open_time_required',
          path: ['operating_hours', index, 'open_time']
        })
      }
      if (row.is_open && (row.close_time === null || row.close_time === undefined)) {
        issues.addIssue({
          code: 'custom',
          message: 'close_time_required',
          path: ['operating_hours', index, 'close_time']
        })
      }
    })
  })
